module.exports = __webpack_public_path__ + "img/编组 3备份 3_1@2x.77106dc7.png";